import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import Pluralize from 'react-pluralize';

import { useTableContext } from './TableContext';
import Actions from './Actions';

export default function ContextMenu({ groupActions }) {
  const { dispatch, state } = useTableContext();
  const selectedCount = state.selectedRows.length;

  const clearSelected = () => {
    Actions.allRowsToggle(dispatch, false);
  };

  if (selectedCount < 1) {
    return null;
  }

  return (
    <div
      className={'context-menu position-absolute w-100 py-2 px-3 '
                + 'd-flex justify-content-between align-items-center rounded-3 fw-light'}
    >
      <div className="py-2">
        {groupActions.length === 0 ? 'Selected ' : 'Edit '}
        <Pluralize singular="item" count={selectedCount} />
      </div>

      <div>
        {groupActions.map((item) => (
          <Button
            key={item.iconClass}
            onClick={() => item.onClick(state.selectedRows, clearSelected)}
            variant="link"
            className="p-2"
          >
            <div className="icon-with-text">
              <i className={`small-icon ${item.iconClass}`} />
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
}

ContextMenu.propTypes = {
  groupActions: PropTypes.arrayOf(PropTypes.object),
};

ContextMenu.defaultProps = {
  groupActions: [],
};
